import { render, staticRenderFns } from "./aRmsRevenueChannelsChart.vue?vue&type=template&id=6406925e"
import script from "./aRmsRevenueChannelsChart.vue?vue&type=script&lang=js"
export * from "./aRmsRevenueChannelsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports